import VehiclesError from './VehiclesError.js'

export class GetPaginationSearchUrlVehiclesError extends VehiclesError {}
